import palette from 'lib/styles/palette';
import styled from 'styled-components';

const Background = ({ children }) => {
  return <BackgroundBlock>{children}</BackgroundBlock>;
};

export default Background;

const BackgroundBlock = styled.div`
  width: 100%;
  height: 100%;
  background: ${palette.gray[0]};
  overflow-y: auto;
`;
